module.exports = __webpack_public_path__ + "img/require-1.fbb70a81.png";